//Parameter value type -> parameter value type on Revit - subset of the revit types, only text and number.

export const ParameterTypeList = ['TEXT', 'NUMBER'] as const;

export type ParameterType = typeof ParameterTypeList[number];


